import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import { SettingsBackupRestore } from "@material-ui/icons";
import axios from "axios";
import Cookies from "universal-cookie";
const cookies = new Cookies();

export default class TimesheetStagingRerun extends Component {
  constructor(props) {
    super();
    this.state = {
      showComputeModal: false,
      disableCompute: false,
      updated_by: cookies.get("email"),
      created_by: cookies.get("email"),
      status: 3
    };
    this.handleshowComputeModal = this.handleshowComputeModal.bind(this);
  }

  handleshowComputeModal = (e) => {
    this.setState({ showComputeModal: !this.state.showComputeModal });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ disableCompute: true });
    axios.post("api/stg_rerun/" + this.props.id, this.state).then((res) => {
      this.props.parentCallback(true);
      this.setState({ showComputeModal: false });
      this.setState({ disableCompute: false });
    });
  };

  render() {
    return (
      <>
        <button
          className="btn btn-outline-warning btn-sm float-right"
          title="Re-run Computation"
          onClick={this.handleshowComputeModal}
        >
          <SettingsBackupRestore />
        </button>
        <Modal
          size="md"
          show={this.state.showComputeModal}
          onHide={() =>
            this.setState({ showComputeModal: !this.state.showComputeModal })
          }
        >
          <Modal.Header closeButton>
            <h4>Re-run timesheet computation:<br/>{this.props.name}</h4>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={this.handleSubmit} id="contact-form">
              <div className="row">
                <div className="form-group col-md-12 col-sm-12">
                  <label>Are you sure to re-run timesheet computation?</label>
                </div>
              </div>

              <div className="float-right">
                <button
                  disabled={this.state.disableCompute}
                  type="submit"
                  className="btn btn-primary btn-sm mr-2"
                >
                  Re-run {this.state.disableCompute ? <span class="spinner spinner-border spinner-border-sm" id="spinner" role="status" aria-hidden="true">
                    </span> : ""
                    }
                </button>
                <button
                  onClick={this.handleshowComputeModal}
                  className="btn btn-danger btn-sm"
                  type="button"
                >
                  Cancel
                </button>
              </div>
            </form>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}
